// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array } from 'prop-types'
import { createPortal } from 'react-dom'
import { connect } from 'react-redux'
import Notifications from 'react-notification-system-redux'

const notificationsWrapper = document.getElementById('notifications-wrapper')

const ReduxNotifications = ({ notifications }) => (
  createPortal(
    <Notifications notifications={notifications} />,
    notificationsWrapper,
  )
)

ReduxNotifications.propTypes = {
  notifications: array.isRequired,
}

const mapStateToProps = ({ notifications }) => ({ notifications })

export default connect(mapStateToProps)(ReduxNotifications)
